// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app\\components\\pages\\book-studio\\index.ts"
);
import.meta.hot.lastModified = "1757171103291.8179";
}
// REMIX HMR END

export { StudioHeroSection, StudioInfoSection } from "./StudioHeroSection/StudioHeroSection";
export { CrewSection } from "./CrewSection/CrewSection";
export { EquipmentSection } from "./EquipmentSection/EquipmentSection";